import { render, staticRenderFns } from "./deferInvoicing.vue?vue&type=template&id=332d639e&scoped=true&"
import script from "./deferInvoicing.vue?vue&type=script&lang=js&"
export * from "./deferInvoicing.vue?vue&type=script&lang=js&"
import style0 from "./deferInvoicing.vue?vue&type=style&index=0&id=332d639e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332d639e",
  null
  
)

export default component.exports